'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../../../common/providers/ClaimBuilder/index.js');
var SessionContext = require('../../../../common/providers/SessionContext.js');
var useAnalytics = require('../../../../common/providers/useAnalytics.js');
var PackageSelectionTitle = require('../../../../common/views/PackageSelection/PackageSelectionTitle.js');
var PackageSelectionViewRoot = require('../../../../common/views/PackageSelection/PackageSelectionViewRoot.js');
var ViewWrapper = require('../../components/ViewWrapper.js');
var PackageSelectionProvider = require('../../../../common/views/PackageSelection/PackageSelectionProvider.js');
var PackagesContainer = require('../../../../common/views/PackageSelection/PackagesContainer.js');
var PackageSelectionCard = require('./PackageSelectionCard.js');
var AgentNavigatorProvider = require('../../providers/AgentNavigatorProvider.js');
var IframeHeight = require('../../components/IframeHeight.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageSelectionView = () => {
  var _Object$keys;
  const {
    state: {
      packageClaims,
      claimType
    },
    handleCompletePackageClaimSelection,
    handleNavigateBack
  } = index.useClaimBuilder();
  const {
    claimsButtonNext,
    claimsSelectionIneligiblePackage
  } = nthHookTranslations.useTranslations();
  const {
    navigateToOrderOverview
  } = AgentNavigatorProvider.useAgentNavigator();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const {
    selectedShipments,
    eligibleShipments,
    ineligibleShipments
  } = PackageSelectionProvider.usePackageSelection();
  return /*#__PURE__*/React__default["default"].createElement(ViewWrapper["default"], {
    dismissButton: {
      onClick: () => navigateToOrderOverview()
    },
    backButton: {
      onClick: () => {
        logEvent({
          event_type: useAnalytics.ClaimsEventTypes.SHIPMENT_SELECTED_BACK,
          event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_SELECTION,
          page_step: useAnalytics.ClaimsPageStep.SELECTION,
          order_number: orderNumber,
          claim_reason: claimType
        });
        handleNavigateBack();
      }
    },
    bottomButton: (_Object$keys = Object.keys(packageClaims)) !== null && _Object$keys !== void 0 && _Object$keys.length ? {
      children: claimsButtonNext,
      onClick: () => {
        logEvent({
          event_type: useAnalytics.ClaimsEventTypes.SHIPMENT_SELECTED_NEXT,
          event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_SELECTION,
          page_step: useAnalytics.ClaimsPageStep.SELECTION,
          order_number: orderNumber,
          claim_reason: claimType
        });
        handleCompletePackageClaimSelection();
      }
    } : undefined
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h1",
    containerCustomStyle: {
      textAlign: 'center',
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(PackageSelectionTitle["default"], null)), /*#__PURE__*/React__default["default"].createElement(PackagesContainer["default"], null, [...selectedShipments, ...eligibleShipments].map(shipment => /*#__PURE__*/React__default["default"].createElement(PackageSelectionCard["default"], {
    shipment: shipment,
    key: shipment.id
  }))), ineligibleShipments.length ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, eligibleShipments.length + selectedShipments.length > 0 && /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    containerCustomStyle: {
      textAlign: 'center',
      margin: '2rem 0 1rem 0'
    }
  }, claimsSelectionIneligiblePackage), /*#__PURE__*/React__default["default"].createElement(PackagesContainer["default"], null, ineligibleShipments.map(shipment => /*#__PURE__*/React__default["default"].createElement(PackageSelectionCard["default"], {
    shipment: shipment,
    key: shipment.id
  })))) : null);
};
const PackageSelectionWithProviders = () => /*#__PURE__*/React__default["default"].createElement(IframeHeight["default"], null, /*#__PURE__*/React__default["default"].createElement(nthHookTranslations.TranslationsProvider, {
  translationKeys: ['claimsButtonNext', 'claimsSelectionIneligiblePackage']
}, /*#__PURE__*/React__default["default"].createElement(PackageSelectionViewRoot["default"], null, /*#__PURE__*/React__default["default"].createElement(PackageSelectionView, null))));

exports["default"] = PackageSelectionWithProviders;
